export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: 'Tongits Pinoy',

    /** 公司名称 */
    name: 'Mobile KIK Limited',
    /** 公司微信 */
    wechat: 'Tongits Pinoy',
    /** 公司微信 */
    facebook: '@TongitsPinoyGlobal',
    /** 公司邮箱 */
    email: 'Tongits Pinoy@Tongits Pinoy.com',
    /** 公司手机 */
    phone: 'Tongits Pinoy',
    /** 公司电话 */
    tel: 'Tongits Pinoy',
    /** 公司地址 */
    address: 'Tongits Pinoy',
    /** 备案号 */
    keepOnRecordIcp: 'Tongits Pinoy',
    /** 备案号 */
    cookiePolicyPath: '/Legal/cookiePolicy',

  appDownLoadUrl: {
    ios:"https://apps.apple.com/us/app/id1507313633",
    android:"https://play.google.com/store/apps/details?id=com.tongits.playpinoy",
    pc:"https://res.tongitspinoy.com/TongitsPinoy.apk",
    local:"/static/TongitsPinoy.apk"
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js